
import { Typography } from "@mui/material";
import React, { useRef, useEffect, useState } from "react";

export default function Countdown({ time, pause }) {
    const [num, setNum] = useState(time);

    let intervalRef = useRef();

    const decreaseNum = () => setNum((prev) => prev - 1);

    useEffect(() => {
        intervalRef.current = setInterval(decreaseNum, 1000);

        return () => clearInterval(intervalRef.current);
    }, []);


    return (
        <div>
            <Typography>Code expires in</Typography>
            <Typography fontWeight={600} fontSize={20}>
                {parseInt(num / 60)} : {num - parseInt(num / 60) * 60}
            </Typography>
        </div>
    );
}